module.exports = __WEBPACK_EXTERNAL_MODULE_moment__;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = moment
// module chunks = 0